"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jumpEgg = {
    name: "jump",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["j", "u", "m", "p"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/sxCEpfI.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "350px";
        img.style.height = "300px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 180px)";
        img.style.bottom = "-450px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 30);
        window.setTimeout(function () {
            img.style.bottom = "-450px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
    },
};
exports.default = jumpEgg;
